module.exports = __webpack_public_path__ + "static/media/pf28.c76ec9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf28.png
// module id = 1067
// module chunks = 0